import { JSX, useMemo } from 'react'

import { BaseCrud, Static } from 'core-components/types'

import { IBaseDropDown, IPropsForRender } from '../../interface/IToolbarProps'

export interface IFormatCrudItem<T> {
  key: T
  value: string
}

interface IProps<T> {
  format: string
  component: (props: IPropsForRender<T> & IBaseDropDown<T>) => JSX.Element
}

export function BaseDropDown<T>(props: IProps<T> & IBaseDropDown<T>) {
  const source = useMemo(() => {
    const formatItems: IFormatCrudItem<T>[] = props.formats.map((item) => ({
      key: item.style,
      value: item.label,
      icon: item.icon,
    }))
    return new BaseCrud({
      fetcher: new Static(formatItems),
      defaultPaging: {
        page: 0,
        pageSize: formatItems.length,
      },
      keyField: 'key',
    })
  }, [props.formats])

  const propsForRenderComponent = useMemo(() => {
    return {
      defaultValue: props.defaultValue,
      source: source,
      className: props.className,
      disabled: props.disabled,
      format: props.format,
      onToggle: props.onToggle,
      label: props.label,
      formats: props.formats,
      formatKeyField: props.formatKeyField,
    }
  }, [
    props.defaultValue,
    source,
    props.className,
    props.disabled,
    props.format,
    props.onToggle,
    props.label,
    props.formats,
    props.formatKeyField,
  ])

  return <props.component {...propsForRenderComponent} />
}
